// «تماشای یک رخداد»: چقدر روی صفحه‌اش ماند و روی کدام لینکش زد (WHOSUP-297).
//
// منطقِ خالص — بدونِ تایمر و شبکه — تا با `npm test` آزموده شود. ثبتِ واقعی
// در `analytics.ts` است (`trackItemDwell` / `trackItemLink`).

/** لینک‌های بیرونیِ صفحه‌ی رخداد. برچسبِ ثابت، نه نشانی — نشانی هیچ‌وقت ذخیره نمی‌شود. */
export type ItemLink =
  /** لینکِ منبع/معرفی (همان «رفرنس»). */
  | 'source'
  /** منبعِ دیگری که برای یک فیلد مقدارِ متفاوت گفته. */
  | 'alt_source'
  /** لینکِ یک سانس از فهرستِ چند زمان/مکان. */
  | 'occurrence'
  | 'ticket'
  | 'directions';

/**
 * بازدیدِ کوتاه‌تر از این ثبت نمی‌شود: باز و بسته شدنِ فوری (برگشتِ اشتباهی،
 * دوبار اجرای افکت در StrictMode) «تماشا» نیست و فقط میانگین را پایین می‌کشد.
 */
export const MIN_DWELL_MS = 500;

/**
 * بازدیدِ بلندتر از این بریده می‌شود. صفحه‌ای که ساعت‌ها باز مانده یعنی
 * کاربر رفته، نه این‌که می‌خوانده؛ بدونِ سقف یک عددِ پرت کلِ میانگین را می‌برد.
 */
export const MAX_DWELL_MS = 30 * 60_000;

/**
 * زمان‌سنجِ «فقط وقتی جلوی چشم است».
 *
 * ⚠ مکث لازم است، نه تزئین: دکمه‌ی بلیط یا منبع مرورگر/اپِ دیگری را باز
 * می‌کند و صفحه‌ی ما همچنان «باز» است. بدونِ مکث، ده دقیقه خریدِ بلیط در
 * سایتِ دیگر به‌عنوانِ ده دقیقه خواندنِ صفحه‌ی ما ثبت می‌شد.
 */
export interface DwellTimer {
  pause: (at: number) => void;
  resume: (at: number) => void;
  /** کلِ زمانِ جلوی چشم تا `at`. */
  elapsed: (at: number) => number;
}

export function makeDwellTimer(start: number): DwellTimer {
  let total = 0;
  let since: number | null = start;
  return {
    pause(at) {
      if (since === null) return;
      total += Math.max(0, at - since);
      since = null;
    },
    resume(at) {
      if (since === null) since = at;
    },
    elapsed(at) {
      return total + (since === null ? 0 : Math.max(0, at - since));
    },
  };
}

/** مدتی که واقعاً ثبت می‌شود، یا `null` اگر ارزشِ ثبت ندارد. */
export function dwellToRecord(ms: number): number | null {
  if (!Number.isFinite(ms) || ms < MIN_DWELL_MS) return null;
  return Math.round(Math.min(ms, MAX_DWELL_MS));
}
